import { BRAND_SECONDARY } from "../../../utils/Styles";
import React from "react";
import {
  Breadcrumb,
  Callout,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  PrimaryButton,
  SelectionMode,
  Stack,
  Text,
  ITag,
  DefaultButton,
  DayOfWeek,
  Calendar,
  FocusTrapZone,
} from "@fluentui/react";
import { mdiDotsVertical } from "@mdi/js";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteActivityUpdates,
  getActivityUpdates,
  getAllCustomers,
  getDatacentersForACustomer,
} from "../../../services/customers/CustomerService";
import { IActivityUpdate } from "../../../vm";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { ToastContext } from "../../common/ToastProvider";
import Icon from "@mdi/react";
import {
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from "../../common/Constants";
import { Loading } from "../../../services/Loading";
import NoDataTile from "../../common/NoDataTile";
import ManageAUDialog from "./ManageAUDialog";
import { parseJwt } from "../../../services/UtilService";
import moment from "moment";
import TotalNumbers from "../../common/TotalNumbers";

let calendarButtonElement: HTMLElement;
export interface ActivityUpdatesProps { }

const ActivityUpdates: React.FC<ActivityUpdatesProps> = () => {
  // custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    activityUpdates: [],
    searchObj: {
      customerId: params.customerId,
      date: moment().subtract(1, "month").toDate(),
    },
    manageAuDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    showCallender: false,
  } as {
    isLoading: boolean;
    activityUpdates: IActivityUpdate[];
    searchObj: {
      customerId: string;
      date: string | Date;
    };
    manageAuDialog: {
      isOpen: boolean;
      index?: number;
      data?: IActivityUpdate;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IActivityUpdate;
    };
    showCallender: boolean;
  });

  const [customer, setCustomer] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
  } as {
    isLoading: boolean;
    customer: any;
  });

  const [datacenters, setDatacenters] = React.useState({
    isLoading: false,
    datacenterDropdown: [],
    datacenterDict: {},
  } as {
    isLoading: boolean;
    datacenterDropdown: ITag[];
    datacenterDict: any;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllActivityUpdates();
      await getACustomer();
      await getDatacenters();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setCustomer({ ...customer, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result?.success) {
      setCustomer({
        ...customer,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setCustomer({ ...customer, isLoading: false });
    }
  };

  const getAllActivityUpdates = async () => {
    setState({ ...state, isLoading: true });
    let search = { ...state.searchObj };
    search.date = moment(search.date).format("YYYY-MM-DD");
    let result = await getActivityUpdates(search);
    if (result?.success) {
      setState({
        ...state,
        activityUpdates: result.data,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting activity updates",
        "error"
      );
    }
  };

  const getDatacenters = async () => {
    setDatacenters({ ...datacenters, isLoading: true });
    let result = await getDatacentersForACustomer({
      customerId: params.customerId,
    });
    if (result?.success) {
      let datacenterDropdown: ITag[] = [];
      let datacenterDict: any = {};

      result.data?.forEach((item) => {
        datacenterDropdown.push({
          key: item._id as string,
          name: item.name,
        });
        datacenterDict[item._id as string] = item.name;
      });

      setDatacenters({
        ...datacenters,
        datacenterDropdown,
        datacenterDict,
        isLoading: false,
      });
    } else {
      setDatacenters({ ...datacenters, isLoading: false });
      showToast(result?.message || "Error while getting datacenters", "error");
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let activityUpdates = undefined;
    if (index !== undefined) {
      activityUpdates = { ...state.activityUpdates[index] };
    }
    setState({
      ...state,
      manageAuDialog: {
        isOpen,
        index,
        data: activityUpdates,
      },
    });
  };

  const handleDialogClose = (data: IActivityUpdate) => {
    let activityUpdates = [...state.activityUpdates];
    if (data) {
      if (state.manageAuDialog.index !== undefined) {
        activityUpdates[state.manageAuDialog.index] = data;
        showToast("Activity Updates updated successfully", "success");
      } else {
        activityUpdates.unshift(data);
        showToast("Activity Updates added successfully", "success");
      }
    }
    setState({
      ...state,
      manageAuDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      activityUpdates,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deleteAu = async (item: IActivityUpdate, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete activity update",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteActivityUpdates(item);
        if (result?.success) {
          showToast("Activity Updates deleted successfully", "success");
          let activityUpdates = [...state.activityUpdates];
          activityUpdates.splice(index, 1);
          setState({
            ...state,
            activityUpdates,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting activity updates",
            "error"
          );
        }
      }
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color={BRAND_SECONDARY}
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={`Edit Previous Meeting`}
          //     id={`editEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={`Delete Previous Meeting`}
          //     id={`deleteEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteSd(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      //  case "content":
      //     return (
      //       <Text styles={{ root: { fontWeight: 600 } }}>
      //         {item[column.fieldName as any]}
      //       </Text>
      //     );
      case "datacenterIds":
        return (
          <Text>
            {item.datacenterIds?.length > 0
              ? item.datacenterIds
                ?.map((d: any) => datacenters.datacenterDict[d])
                .join(", ")
              : "All Datacenter"}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IActivityUpdate
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const onSearch = async () => {
    await getAllActivityUpdates();
  };

  return (
    <React.Fragment>
      {(state.isLoading || customer.isLoading || datacenters.isLoading) && (
        <Loading />
      )}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: customer.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${customer.customer._id}`);
                },
              },
              {
                text: "Activity Updates",
                key: "activity-updates",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal wrap tokens={childrenGap}>
            <Stack.Item>
              <div
                ref={(calendarBtn) => (calendarButtonElement = calendarBtn!)}
              >
                <DefaultButton
                  text={
                    !state.searchObj.date
                      ? "Select a Year"
                      : moment(state.searchObj.date).format("MMM-YYYY")
                  }
                  onClick={() => setState({ ...state, showCallender: true })}
                  className="month-picker-btn"
                />
              </div>
              {state.showCallender && (
                <Callout
                  isBeakVisible={false}
                  gapSpace={0}
                  doNotLayer={false}
                  target={calendarButtonElement}
                  directionalHint={DirectionalHint.bottomLeftEdge}
                  onDismiss={() => closeCallender()}
                  setInitialFocus
                >
                  <FocusTrapZone
                    firstFocusableSelector="ms-DatePicker-day--today"
                    isClickableOutsideFocusTrap
                  >
                    <Calendar
                      // eslint-disable-next-line react/jsx-no-bind
                      onSelectDate={(date: Date | null | undefined) => {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            date: date as Date,
                          },
                          showCallender: false,
                        });
                      }}
                      onDismiss={() => closeCallender()}
                      isMonthPickerVisible={true}
                      value={new Date(state.searchObj.date)}
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DayPickerStrings}
                      isDayPickerVisible={false}
                      highlightCurrentMonth={false}
                      highlightSelectedMonth={true}
                      showMonthPickerAsOverlay={false}
                      showGoToToday={false}
                    />
                  </FocusTrapZone>
                </Callout>
              )}
            </Stack.Item>
            <Stack.Item>
              <PrimaryButton text="Search" onClick={onSearch} />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <Stack.Item>
              <TotalNumbers value={state.activityUpdates.length} />
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item align="end">
                <PrimaryButton
                  text="Add Activity Updates"
                  onClick={() => handleDialogOpen(true)}
                  className="borderless-btn bg-white"
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>

        <Stack.Item>
          {state.activityUpdates && state.activityUpdates.length > 0 ? (
            <Fabric>
              <DetailsList
                items={state.activityUpdates}
                columns={
                  ![2, 4, 5].includes(tokenData.role)
                    ? [
                      //   {
                      //     key: "legendId",
                      //     name: "Legend Id",
                      //     fieldName: "legendId",
                      //     minWidth: 150,
                      //     maxWidth: 200,
                      //     isResizable: true,
                      //   },
                      {
                        key: "content",
                        name: "Content",
                        fieldName: "content",
                        minWidth: 700,
                        maxWidth: 900,
                        isResizable: true,
                      },
                      {
                        key: "datacenterIds",
                        name: "Datacenters",
                        fieldName: "datacenterIds",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 90,
                        maxWidth: 150,
                        isResizable: true,
                      },
                    ]
                    : [
                      {
                        key: "content",
                        name: "Content",
                        fieldName: "content",
                        minWidth: 700,
                        maxWidth: 900,
                        isResizable: true,
                      },
                      {
                        key: "datacenterIds",
                        name: "Datacenters",
                        fieldName: "datacenterIds",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                    ]
                }
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Activity Updates Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deleteAu(
                    state.manageActionsCallout.data as IActivityUpdate,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageAuDialog.isOpen && (
        <ManageAUDialog
          data={state.manageAuDialog.data}
          handleLoading={handleLoading}
          handleDialogClose={(data: IActivityUpdate) => handleDialogClose(data)}
          customerId={params.customerId}
          datacenterDropdown={datacenters.datacenterDropdown}
        />
      )}
    </React.Fragment>
  );
};

export default ActivityUpdates;
